// src/api/axiosInstance.ts
import axios, { AxiosInstance } from 'axios';
import { BASE_API_URL, REQUEST_TIMEOUT } from './config';
import { getRestaurantId } from './tokenUtils';

const setupInterceptors = (
  instance: AxiosInstance,
  {
    requiresRestaurantId = true,
  }: {
    requiresRestaurantId?: boolean;
  } = {}
) => {
  // Add restaurant ID header to requests
  instance.interceptors.request.use(config => {
    if (requiresRestaurantId) {
      const restaurantId = getRestaurantId();
      if (restaurantId) {
        config.headers['restaurant-id'] = restaurantId;
      }
    }
    return config;
  });

  // Handle response errors
  instance.interceptors.response.use(
    response => response,
    async error => {
      return Promise.reject(error);
    }
  );
};

// Default axios instance
const axiosInstance = axios.create({
  baseURL: BASE_API_URL,
  timeout: REQUEST_TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  },
});

setupInterceptors(axiosInstance, {});

// Function to create custom axios instance
export const createAxiosInstance = ({
  baseURL,
  timeout,
  requiresRestaurantId = true,
  ...rest
}: {
  baseURL?: string;
  timeout?: number;
  requiresRestaurantId?: boolean;
  [key: string]: unknown;
} = {}): AxiosInstance => {
  const customInstance = axios.create({
    baseURL: baseURL || BASE_API_URL,
    timeout: timeout || REQUEST_TIMEOUT,
    headers: {
      'Content-Type': 'application/json',
    },
    ...rest,
  });

  setupInterceptors(customInstance, { requiresRestaurantId });

  return customInstance;
};

export default axiosInstance;
